function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F5B53"
    },
    d: "M481.103,512H145.655V0h335.448c9.754,0,17.655,7.901,17.655,17.655v476.69 C498.759,504.099,490.858,512,481.103,512"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB8252"
    },
    d: "M145.655,512H75.034c-9.754,0-17.655-7.901-17.655-17.655V17.655C57.379,7.901,65.28,0,75.034,0 h70.621V512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M57.379,17.655c-24.338,0-44.138,19.8-44.138,44.138s19.8,44.138,44.138,44.138V88.276 c-14.601,0-26.483-11.882-26.483-26.483S42.778,35.31,57.379,35.31s26.483,11.882,26.483,26.483c0,4.882,3.955,8.828,8.828,8.828 c4.873,0,8.828-3.946,8.828-8.828C101.517,37.455,81.717,17.655,57.379,17.655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M57.379,114.759c-24.338,0-44.138,19.8-44.138,44.138s19.8,44.138,44.138,44.138v-17.655 c-14.601,0-26.483-11.882-26.483-26.483c0-14.601,11.882-26.483,26.483-26.483s26.483,11.882,26.483,26.483 c0,4.882,3.955,8.828,8.828,8.828c4.873,0,8.828-3.946,8.828-8.828C101.517,134.559,81.717,114.759,57.379,114.759"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M57.379,211.862c-24.338,0-44.138,19.8-44.138,44.138s19.8,44.138,44.138,44.138v-17.655 c-14.601,0-26.483-11.882-26.483-26.483s11.882-26.483,26.483-26.483S83.862,241.399,83.862,256c0,4.882,3.955,8.828,8.828,8.828 c4.873,0,8.828-3.946,8.828-8.828C101.517,231.662,81.717,211.862,57.379,211.862"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M57.379,308.966c-24.338,0-44.138,19.8-44.138,44.138c0,24.338,19.8,44.138,44.138,44.138v-17.655 c-14.601,0-26.483-11.882-26.483-26.483c0-14.601,11.882-26.483,26.483-26.483s26.483,11.882,26.483,26.483 c0,4.882,3.955,8.828,8.828,8.828c4.873,0,8.828-3.946,8.828-8.828C101.517,328.766,81.717,308.966,57.379,308.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M57.379,406.069c-24.338,0-44.138,19.8-44.138,44.138c0,24.338,19.8,44.138,44.138,44.138V476.69 c-14.601,0-26.483-11.882-26.483-26.483c0-14.601,11.882-26.483,26.483-26.483s26.483,11.882,26.483,26.483 c0,4.882,3.955,8.828,8.828,8.828c4.873,0,8.828-3.946,8.828-8.828C101.517,425.869,81.717,406.069,57.379,406.069"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CBB292"
    },
    points: "322.015,52.966 225.106,150.069 251.589,176.552 322.015,105.931 322.21,106.125  322.395,105.931 392.83,176.552 419.313,150.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5896A"
    },
    points: "322.105,105.931 269.237,158.897 269.237,229.517 375.168,229.517 375.168,158.897  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M286.897,326.621h-88.276c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 h88.276c4.873,0,8.828,3.946,8.828,8.828C295.724,322.675,291.769,326.621,286.897,326.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M384,326.621h-61.793c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828H384 c4.873,0,8.828,3.946,8.828,8.828C392.828,322.675,388.873,326.621,384,326.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M445.793,326.621H419.31c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828h26.483 c4.873,0,8.828,3.946,8.828,8.828C454.621,322.675,450.666,326.621,445.793,326.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M445.793,379.586H384c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828h61.793 c4.873,0,8.828,3.946,8.828,8.828C454.621,375.64,450.666,379.586,445.793,379.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M348.69,379.586h-70.621c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828h70.621 c4.873,0,8.828,3.946,8.828,8.828C357.517,375.64,353.562,379.586,348.69,379.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M242.759,379.586h-44.138c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 h44.138c4.873,0,8.828,3.946,8.828,8.828C251.586,375.64,247.631,379.586,242.759,379.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M260.414,432.552h-61.793c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 h61.793c4.873,0,8.828,3.946,8.828,8.828C269.241,428.606,265.287,432.552,260.414,432.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M375.172,432.552h-79.448c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 h79.448c4.873,0,8.828,3.946,8.828,8.828C384,428.606,380.045,432.552,375.172,432.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB292"
    },
    d: "M445.793,432.552h-35.31c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828h35.31 c4.873,0,8.828,3.946,8.828,8.828C454.621,428.606,450.666,432.552,445.793,432.552"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue);
export default __webpack_public_path__ + "static/media/catalogue.fba96b20c6f62d25925d1c0b578b833b.svg";
export { ForwardRef as ReactComponent };